/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
class VoxAd {
	constructor(articleId) {
		this.articleId = articleId;
	}

	init() {
		console.info('[vox] initialized');

		if (typeof window._tx === 'undefined') {
			var s = document.createElement('script');
			s.type = 'text/javascript';
			s.async = true;
			s.src = 'https://st.hbrd.io/ssp.js?t=' + new Date().getTime();
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(s);
		}

		window._tx = window._tx || {};

		window._tx.cmds = window._tx.cmds || [];

		window._tx.cmds.push(() => {
			window._tx.integrateInImage({
				placeId: '6038cec84d506e5804b270f5',
				imageSelector: `article[data-id="${this.articleId}"] .content figure:not([class]) img`,
			});

			window._tx.init({
				onSuccessInImageLoad: (data) => {
					console.info('[ad] onSuccessInImageLoad', data);
				},
				onFailInImageLoad: (data) => {
					console.info('[ad] onFailInImageLoad', data);
					window.yaContextCb.push(() => {
						Ya.adfoxCode.create({
							ownerId: 353925,
							containerId: 'adfox_170618058348652321',
							params: {
								pp: 'g',
								ps: 'enis',
								p2: 'hzcf',
								puid1: '',
								puid2: '',
								puid3: '',
							},
							onClose: () => {
								console.info('[ad] Adfox_callback_onClose');
							},
							onError: (error) => {
								console.info('[ad] Adfox_callback_onError');
							},
							onLoad: (data) => {
								console.info('[ad] Adfox_callback_onLoad');
							},
							onRender: () => {
								console.info('[ad] Adfox_callback_onRender');
							},
							onStub: () => {
								console.info('[ad] Adfox_callback_onStub');
							},
						});
					});
				},
			});
		});
	}
}

export default VoxAd;
